export default {"src":"/_next/static/media/menu.090178be.svg","height":20,"width":28,"blurWidth":0,"blurHeight":0};